import DateUtils from '../../utils/dateUtils'

let Periodicidad = {
    none:0,
    min:1,
    min3:2,
    min5: 3,
    min10: 4,
    min15: 9,
    min30: 9,
    hour: 7,
    hour30: 8,
    day: 9,
    week: 10,
    day10: 11,
    month: 12,
    year: 13,


    truncarAPeriodicidad: function (momentDate, periodicidad) {
        if (periodicidad === this.min10) {
            momentDate = momentDate.set("minutes", Math.trunc(momentDate.get("minutes") / 10) * 10);
            momentDate = momentDate.startOf("minutes");
        } else if (periodicidad === this.min5) {
            momentDate = momentDate.set("minutes", Math.trunc(momentDate.get("minutes") / 5) * 5);
            momentDate = momentDate.startOf("minutes");
        } else if (periodicidad === this.hour) {
            momentDate = momentDate.startOf("hours");
        } else if (periodicidad === this.day) {
            momentDate = momentDate.startOf("days");
        }
        return momentDate;
    },

    siguienteN: function(fecha, periodicidad, n, tuncar) {
        if (fecha && periodicidad){
            if (tuncar)
                fecha= this.truncarAPeriodicidad(fecha,periodicidad)
            if (periodicidad === this.min5){
                return DateUtils.addMinutes(fecha,n*5);
            } else if (periodicidad === this.min10){
                return DateUtils.addMinutes(fecha,n*10);
            } else if (periodicidad === this.hour){
                return DateUtils.addHours(fecha,n);
            } else if (periodicidad === this.day){
                return DateUtils.addDays(fecha,n);
            }  else if (periodicidad === this.week){
                return DateUtils.addWeeks(fecha,n);
            } else if (periodicidad === this.month){
                return DateUtils.addMonths(fecha,n);
            } else if (periodicidad === this.year){
                return DateUtils.addYears(fecha,n);
            }
        }
        return null;
    },

    siguiente: function(fecha, periodicidad) {
        return this.siguienteN(fecha,periodicidad,1)
    },

    anterior: function(fecha, periodicidad) {
        return this.siguienteN(fecha,periodicidad,-1)
    }
}

export { Periodicidad as default };
